import { useContext } from 'react'
import { Link } from 'react-router'
import { AppBar, Avatar, CssBaseline, Grid, IconButton, Toolbar, Typography } from '@mui/material'
import { IAgent } from '../../lib/interface/agent'
import { getIdNoeudsAscendants, getInitiales } from '../Utils/fonctions'
import { useFetchContext } from '../../hook/UseFetchContext'
import AuthentificationContext from '../../authentification/AuthentificationContext'
import { CLEAR_AGENT, SET_AGENT_SELECTED, SET_NOEUD_OUVERT, SET_NOEUD_SELECTED } from '../../lib/typeKey'

const styles = { avatar: { color: 'primary.main', backgroundColor: 'secondary.main' } }

function getAgentByMatricule(agents: IAgent[], matricule: string) {
  return agents.filter((agent) => agent.identifiantsAgent.matricule === matricule)
}

export default function Header() {
  const { nom, prenom, prenomNom, matricule, idep } = useContext(AuthentificationContext)
  const { state, dispatch } = useFetchContext()
  const agentsTotal = state.agentTotalState.agentsTotal
  const noeuds = state.dimensionState.noeuds
  const photo = state.agentState.photoConnectedAgent
  const titre = 'Annuaire des personnes et services'

  const clickAvatar = (agentsTotal: IAgent[]) => () => {
    if (matricule) {
      const agentMatricule = getAgentByMatricule(agentsTotal, matricule)[0]
      if (agentMatricule) {
        // maj de l'agent sélectionné
        dispatch({ type: SET_AGENT_SELECTED, payload: agentMatricule })
        // maj du noeud sélectionné et des noeuds ouverts
        let idNoeudSelected = null
        let noeudsAscendants: string[] = []
        const noeud = noeuds.filter((n: INoeudDimension) => n.valeurs.includes(agentMatricule.affectation.unite))

        if (noeud.length > 0) {
          idNoeudSelected = noeud[0].identifiantNoeudDimension
          noeudsAscendants = getIdNoeudsAscendants(noeuds, noeud[0])
        }
        dispatch({ type: SET_NOEUD_OUVERT, payload: noeudsAscendants })
        dispatch({ type: SET_NOEUD_SELECTED, payload: idNoeudSelected })
      }
    }
  }

  const clickLogoInsee = () => {
    dispatch({ type: CLEAR_AGENT })
    dispatch({ type: SET_NOEUD_OUVERT, payload: [] })
    dispatch({ type: SET_NOEUD_SELECTED, payload: null })
  }

  return (
    <>
      <CssBaseline />
      <AppBar
        position="relative"
        role="banner"
      >
        <Toolbar>
          <Grid
            container
            sx={{
              width: 1,
              justifyContent: 'space-between'
            }}
          >
            <Grid
              container
              sx={{ alignItems: 'center' }}
            >
              <Grid>
                <IconButton
                  component={Link}
                  to="/"
                  aria-label="Logo de l'Insee, cliquez dessus pour revenir à l'accueil du trombi"
                  onClick={clickLogoInsee}
                  data-cy="logo-insee"
                  sx={{ padding: 0 }}
                >
                  <img
                    style={{ maxHeight: '66px' }}
                    src={'/insee-logo.webp'}
                    alt="Logo de l'Insee, cliquez dessus pour revenir à l'accueil du trombi"
                  />
                </IconButton>
              </Grid>
              <Grid>
                <Typography
                  variant="h5"
                  component="h1"
                  sx={{ flexGrow: 1 }}
                >
                  {titre}
                </Typography>
              </Grid>
            </Grid>
            <Grid>
              <Typography
                variant="body1"
                component="span"
                style={{ marginRight: '15px', fontSize: '1.2rem' }}
              >
                {prenomNom}
              </Typography>
              <IconButton
                component={Link}
                to={`/${idep?.toLowerCase()}`}
                aria-label={`Cliquez dessus pour accéder à votre fiche - ${nom} ${prenom})}`}
                onClick={clickAvatar(agentsTotal)}
                data-cy="avatar-photo"
              >
                <Avatar
                  sx={styles.avatar}
                  alt={'Cliquez dessus pour accéder à votre fiche'}
                  src={'data:image/jpeg;base64,' + photo}
                  style={{ width: 60, height: 60 }}
                >
                  {getInitiales(nom, prenom)}
                </Avatar>
              </IconButton>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
    </>
  )
}
